import { ref } from 'vue'
import { FilterMatchMode } from 'primevue/api'
import { useRouter } from 'vue-router'
import useClient from '../client/apiClient'

export default function useMovimientos() {
  const loading = ref(false)
  const movimiento = ref([])
  const movimientos = ref([])
  const rmovimientos = ref([])
  const messages = ref([])

  const client = useClient()
  const router = useRouter()
  const movtoDialog = ref(false)
  const submitted = ref(false)
  const saving = ref(false)

  const listaByChofer = (periodo) => {
    client.get(`/api/movimientos/${periodo}/lista`).then(response => {
      rmovimientos.value = response.data.data.rmovimientos
      movimientos.value = []
      loading.value = false
    })   
    .catch(function (error) { 
      loading.value = false
    })         
  }

  const detalleByChofer = (id,periodo) => {
    client.get(`/api/movimientos/${id}/${periodo}/detalle`).then(response => {
      movimientos.value = response.data.data.movimientos
      loading.value = false
    })   
    .catch(function (error) { 
      loading.value = false
    })         
  }

  const filters = ref({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  return {
    client,
    router,
    loading,
    movimiento,
    movimientos,
    rmovimientos,
    messages,
    filters,
    movtoDialog,
    submitted,
    saving,
    listaByChofer,
    detalleByChofer
  }
}